// Fix for beforeSubmitSearchForm undefined error - Define this FIRST before any initialization
// This ensures the safe version is available when onclick handlers are set
window.beforeSubmitSearchForm = function(a, b) {
    // Ensure jQuery is available
    if (typeof jQ === 'undefined' || !jQ) {
        console.error('jQuery (jQ) is not defined');
        return false;
    }
    
    // Get the search term from input
    var searchTerm = '';
    var $element = jQ(a);
    
    // Check if element exists and get value
    if ($element && $element.length > 0) {
        searchTerm = $element.val() || '';
    }
    
    // Fallback to event target value if input is empty
    if (!searchTerm && b && b.target) {
        searchTerm = b.target.value || '';
    }
    
    // If still no search term, try to find the input by name="q"
    if (!searchTerm && b && b.target) {
        var $form = jQ(b.target).closest('form');
        if ($form.length > 0) {
            var $input = $form.find('input[name="q"]');
            if ($input.length > 0) {
                searchTerm = $input.val() || '';
            }
        }
    }
    
    // Check if bcsffilter is available
    if (typeof bcsffilter === 'undefined' || !bcsffilter) {
        console.warn('bcsffilter is not defined, using standard form submission');
        // Fallback to standard form submission
        if (b && b.target) {
            var $form = jQ(b.target).closest('form');
            if ($form.length > 0) {
                // Prevent default to avoid double submission
                if (b.preventDefault) {
                    b.preventDefault();
                }
                $form[0].submit();
                return false;
            }
        }
        return false;
    }
    
    // Prevent default form submission
    if (b && b.preventDefault) {
        b.preventDefault();
    }
    if (b && b.stopPropagation) {
        b.stopPropagation();
    }
    
    // Get search redirect URL
    var redirectUrl = bcsffilter.getSearchRedirectUrl(searchTerm);
    
    // Submit search
    bcsffilter.submitSearch(searchTerm, a, redirectUrl, b);
    
    return false;
};

// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
        suggestionMobileStyle: 'style2',
        suggestionStyle2MainContainerSelector: '#searchBarHeader',
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

// #178096
BCSfFilter.prototype.openSuggestionEvent = function(searchBoxId, ev) {
    var self = this;
    // Prevent double tap on iOS
    if (self.isiOS()) {
        jQ('.' + this.class.searchSuggestionItem + ' a')
            .on('touchstart', function() {
                isScrolling = false;
            })
            .on('touchmove', function(e) {
                isScrolling = true;
            })
            .on('touchend', function(e) {
                if (!isScrolling) {
                    window.location = jQ(this).attr('href');
                }
            });
    }
    /* On mobile, prevent body from scrolling if it is full suggestion style */
    var $body = jQ('body');
    if(self.checkIsFullWidthSuggestionMobile(searchBoxId) && !$body.hasClass(self.getClass('searchSuggestionMobileOpen'))){
        $body.addClass(self.getClass('searchSuggestionMobileOpen'));
    }
    jQ('.bc-sf-search-suggestion-wrapper').addClass('is-active');
};

// Close Suggestion Event
BCSfFilter.prototype.closeSuggestionEvent = function(searchBoxId) {
    // Test Mode - Turn on when need check elements of Auto Complete
    // Prevent closing Auto complete when opening Inspect Element
    if (this.getSettingValue('search.suggestionMode') == 'test' || this.checkIsFullWidthSuggestionMobile(searchBoxId)) {
        // if (!jQ('ul.ui-autocomplete').is(":visible")) {
        jQ('.' + this.class.searchSuggestion).show();
        // }
    } else {
        jQ('.' + this.class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').siblings().hide();
    }
    // Always hide loading and show content
    // this.hideSuggestionLoading();
    jQ('.bc-sf-search-suggestion-wrapper').removeClass('is-active');
};
// End #178096